import { render, staticRenderFns } from "./TheSourceCheckbox.vue?vue&type=template&id=b1ef495a&scoped=true&"
import script from "./TheSourceCheckbox.vue?vue&type=script&lang=js&"
export * from "./TheSourceCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceCheckbox.vue?vue&type=style&index=0&id=b1ef495a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ef495a",
  null
  
)

export default component.exports